import React, { useEffect, useState, useMemo } from 'react';
import { Dropdown, Checkbox, Icon, Bubble } from 'tea-component';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import './index.scss';
import classNames from 'classnames';
import { useIntl } from 'umi';

export default function CascadeMetricSelector(props: any) {
  const { value, options, onChange, isShowSelectedNum = false, isCompany = false } = props;

  const { formatMessage } = useIntl();

  // console.log('CascadeMetricSelector', props);

  // const [selectorValue, setSelectorValue] = useState<any[]>(value || []);
  const [selectedOptions, setSelectedOptions] = useState<any[]>([]);
  const [selectedPaValueList, setSelectedPaValueList] = useState<any[]>([]);
  const [selectedSubValueList, setSelectedSubValueList] = useState<any[]>([]);
  const [rightOptions, setRightOptions] = useState<any[]>([]);
  const [selectedCurPa, setSelectedCurPa] = useState<any>('');

  const optionsTotal = useMemo(() => {
    if (!Array.isArray(options)) return 0;
    let temp = 0;
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      if (!option || option.disabled || !Array.isArray(option.children)) continue;
      temp += option.children.filter((item: any) => !item.disabled).length;

      if (option.children?.length == 0) {
        temp++;
      }
    }
    return temp;
  }, [options]);

  const getsubValueList = (paValue: string, list: any) => {
    if (Array.isArray(list) && list.length > 0) {
      const subList = list?.filter((item: any) => item.paValue == paValue);
      return subList?.map((item: any) => item.subValue);
    }
    return [];
  };

  useEffect(() => {
    if (Array.isArray(value) && Array.isArray(options)) {
      const paOptionTemp: any[] = [];
      const subOptionTemp: any[] = [];
      let selectedOptions: any[] = [];
      const valueTemp: any[] = [];

      // 初次打开，全选所有非禁选项
      if (value?.length == 1 && value[0][0] == 'All') {
        // eslint-disable-next-line no-restricted-syntax
        for (const n in options) {
          if (!options[n].disabled && options[n].children?.length > 0) {
            if (!paOptionTemp?.includes(options[n]?.value)) {
              paOptionTemp.push(options[n]?.value);
            }
            // eslint-disable-next-line no-restricted-syntax
            for (const m in options[n].children) {
              if (!options[n].children[m].disabled) {
                selectedOptions.push([options[n], options[n].children[m]]);
                valueTemp.push([options[n]?.value, options[n].children[m]?.value]);
                if (!paOptionTemp?.includes(options[n].children[m]?.value)) {
                  subOptionTemp.push({
                    paValue: options[n]?.value,
                    subValue: options[n].children[m]?.value,
                  });
                }
              }
            }
          } else if (!options[n].disabled && options[n].children?.length == 0) {
            paOptionTemp.push(options[n]?.value);
            selectedOptions.push([options[n], options[n]]);
            valueTemp.push([options[n]?.value, options[n]?.value]);
          }
        }
        // 全选回填
        if (onChange instanceof Function) {
          onChange(sortByOption(valueTemp));
        }
      } else {
        // console.log('valuevaluevaluevalue', value);
        selectedOptions = value
          ?.map((item) => {
            if (!Array.isArray(item) || item.length < 2) return;
            const [parent, child] = item;

            const parentOption = options?.find((subItem) => subItem?.value === parent) || {};
            if (!parentOption || !Array.isArray(parentOption.children)) return null;

            // 获取勾选的左侧选项
            if (!paOptionTemp?.includes(parent) && !parentOption?.disabled) {
              paOptionTemp.push(parent);
            }
            if (parentOption?.children?.length > 0) {
              const childOption = parentOption?.children?.find(
                (subItem: any) => subItem?.value === child,
              );
              // 获取勾选的右侧选项
              if (
                !getsubValueList(parentOption?.value, subOptionTemp)?.includes(child) &&
                !childOption?.disabled
              ) {
                subOptionTemp.push({ paValue: parentOption?.value, subValue: child });
              }
              if (!childOption) return null;
              return [parentOption, childOption];
            }
            if (parentOption?.children?.length == 0) {
              return [parentOption, parentOption];
            }
          })
          .filter((item) => item);
      }
      // console.log(paOptionTemp, subOptionTemp, selectedOptions);
      setSelectedPaValueList(paOptionTemp);
      setSelectedSubValueList(subOptionTemp);
      setSelectedOptions(selectedOptions);
      if (selectedCurPa != '') {
        const curPaItem = options.find((subItem) => subItem?.value === selectedCurPa);
        setSelectedCurPa(curPaItem.value);
        if (curPaItem.children && Array.isArray(curPaItem.children)) {
          const subList = curPaItem.children?.map((subItem: any) => {
            return {
              ...subItem,
              paValue: curPaItem.value,
            };
          });
          setRightOptions(subList);
        } else {
          setRightOptions([]);
        }
      }
    }
  }, [options, selectedCurPa, value]);

  const paOptionHandle = (item: any) => {
    setSelectedCurPa(item.value);
  };

  const paCheckHandle = (boo: boolean, paItem: any) => {
    if (paItem.disabled) return;
    let valueTemp: any = [];
    let paAllList: any = [];
    if (Array.isArray(paItem.children) && paItem.children == 0) {
      paAllList = [[paItem.value, paItem.value]];
    } else {
      const noDisabledPaChildren = Array.isArray(paItem.children)
        ? paItem.children?.filter((item: any) => !item.disabled)
        : [];
      paAllList = noDisabledPaChildren?.map((subItem: any) => {
        return [paItem.value, subItem.value];
      });
    }

    if (Array.isArray(value) && value.length > 0 && value[0].length == 2) {
      const unPaList = value?.filter((item: any) => item[0] != paItem.value) || [];

      const paList = value?.filter((item: any) => item[0] == paItem.value) || [];

      if (paList?.length == 0) {
        // 空选变全选
        valueTemp = [...value, ...paAllList];
      } else if (paList?.length == paAllList?.length) {
        // 全选变空选
        valueTemp = unPaList;
      } else {
        // 半选变全选
        valueTemp = [...unPaList, ...paAllList];
      }
    } else {
      if (boo && Array.isArray(value) && value.length == 0) {
        valueTemp = [...paAllList];
      }
    }

    if (onChange instanceof Function) {
      onChange(sortByOption(valueTemp));
    }
  };

  // 按数据源顺序重新排序
  const sortByOption = (list: any) => {
    const listTemp: any = [];
    for (const n in options) {
      for (const m in list) {
        if (list[m][0] == options[n].value) {
          listTemp.push(list[m]);
        }
      }
    }
    return listTemp;
  };

  const subOptionHandle = (boo: boolean, subItem: any) => {
    // console.log('boobooboo', boo);
    // console.log('subItemsubItem', subItem);
    if (subItem.disabled) return;
    let valueTemp: any = [];
    if (!boo) {
      // 取消选择
      valueTemp = value?.filter((item: any) => item[1] != subItem.value) || [];
    } else {
      // 勾选
      valueTemp = [...value, [subItem.paValue, subItem.value]];
    }
    if (onChange instanceof Function) {
      onChange(sortByOption(valueTemp));
    }
  };

  const getIsHalfSelected = (paItem: any) => {
    if (Array.isArray(value) && value.length > 0 && value[0].length == 2) {
      const paItemDeDisabled = paItem.children?.filter((item: any) => !item.disabled) || [];
      const paList = value?.filter((item: any) => item[0] == paItem.value) || [];
      // console.log('paListpaListpaList', paList);
      // console.log('paItemDeDisabled', paItemDeDisabled);
      // console.log('paItempaItempaItem', paItem);
      if (paList?.length == paItemDeDisabled.length || paList?.length == 0) {
        return false;
      }
      if (paItem.children?.length == 0 && !paItem.disabled) {
        return false;
      }
      return true;
    }
    return false;
  };

  const displayRender = () => {
    if (isShowSelectedNum) {
      return (
        <div className="select-button">
          {selectedOptions?.length === 0 ? (
            <div className="select-button-placeholder">
              {formatMessage({ id: 'dbi_please_select_metrics' })}
            </div>
          ) : (
            <>
              {selectedOptions?.length === optionsTotal ? (
                <div className="select-button-txt">Metrics: All</div>
              ) : (
                <div className="select-button-txt">Metrics: {selectedOptions?.length}</div>
              )}
            </>
          )}
        </div>
      );
    }
    return (
      <div className="select-button">
        {selectedOptions?.length === 0 ? (
          <div className="select-button-placeholder">
            {formatMessage({ id: 'dbi_please_select_metrics' })}
          </div>
        ) : (
          <>
            {selectedOptions?.length === optionsTotal ? (
              <div className="select-button-txt">{formatMessage({ id: 'dbi_all_metrics' })}</div>
            ) : (
              <div className={`dbi-select-value`}>
                {selectedOptions.map((item: any, index: any) => {
                  if (!(Array.isArray(item) && item.length >= 2)) return null;
                  return (
                    <div className="dbi-select-flex" key={index}>
                      <img
                        className="dbi-select-countryicon"
                        src={getDataSourceIcon(
                          isCompany ? item[1].icon : item[1].icon ?? item[0].value,
                        )}
                      />
                      {/* <span>{item[1].text}</span> */}
                      <span>{formatMessage({ id: item[1].text })}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  const onClearHandler = (e: any) => {
    // console.log('eeeee', e);
    if (onChange instanceof Function) {
      onChange([]);
    }
  };

  // console.log('selectedOptions', selectedOptions);
  // console.log('selectedPaValueList', selectedPaValueList);
  // console.log('selectedSubValueList', selectedSubValueList);
  // console.log('rightOptions', rightOptions);
  // console.log('options', options);

  const selectedCurPaValue = useMemo(() => {
    if (selectedCurPa == '' && Array.isArray(options) && options.length > 0) {
      return options[0].value;
    }
    return selectedCurPa;
  }, [props, selectedCurPa]);

  return (
    <Dropdown
      className="dbi-regionselecter dbi-regionselecter--secondary dbi-cascade-metric-selector"
      clearable={!!selectedOptions?.length}
      button={displayRender()}
      appearance="button"
      clickClose={false}
      onClear={onClearHandler}
    >
      {(close) => (
        <div className="dbi-regionselecter-content">
          {/* 左侧选择区域 */}
          <div className="dbi-regionselecter-content-wrap">
            <div className="dbi-regionselecter-checkbox tea-list--option">
              <Checkbox.Group>
                {options.map((item: any, index: any) => {
                  return (
                    <Bubble
                      style={{ maxWidth: '400px' }}
                      dark
                      key={index}
                      content={
                        item.disabled
                          ? item?.messagekey
                            ? formatMessage({ id: item?.messagekey })
                            : item?.message
                          : ''
                      }
                    >
                      <Checkbox
                        name={item.id}
                        key={index}
                        className={classNames({
                          'is-selected': selectedCurPaValue == item.value,
                        })}
                        indeterminate={getIsHalfSelected(item)}
                        disabled={item.disabled}
                        value={selectedPaValueList.includes(item.value)}
                        onChange={(value: any) => {
                          paCheckHandle(value, item);
                        }}
                      >
                        <li
                          className={`dbi-regionselecter-checkitem`}
                          onClick={(e) => {
                            e?.stopPropagation();
                            e?.preventDefault();
                            paOptionHandle(item);
                          }}
                        >
                          <div className="dbi-select-flex">
                            {item.isNoIcon ? null : (
                              <img
                                className="dbi-select-countryicon"
                                src={getDataSourceIcon(item.icon || item.value)}
                              />
                            )}
                            <span>
                              {item.text +
                                (item.children?.length > 0 ? `(${item.children?.length})` : '')}
                            </span>
                          </div>
                          {item.children?.length > 0 && <Icon type="arrowright" />}
                        </li>
                      </Checkbox>
                    </Bubble>
                  );
                })}
              </Checkbox.Group>
            </div>
          </div>
          {/* 右侧选择区域 */}
          {rightOptions.length > 0 && (
            <div className="dbi-regionselecter-content-wrap">
              <div className="dbi-regionselecter-checkbox dbi-regionselecter-checkbox--secondary tea-list--option">
                <Checkbox.Group>
                  {rightOptions.map((item: any, index: any) => {
                    return (
                      <Bubble
                        style={{ maxWidth: '400px' }}
                        dark
                        key={index}
                        content={
                          item.disabled
                            ? item?.messagekey
                              ? formatMessage({ id: item?.messagekey })
                              : item?.message
                            : ''
                        }
                      >
                        <Checkbox
                          name={item.text}
                          key={index}
                          // className={classNames({
                          //   'is-selected': getsubValueList(item?.paValue, selectedSubValueList)?.includes(item.value),
                          // })}
                          disabled={item.disabled}
                          value={getsubValueList(item?.paValue, selectedSubValueList).includes(
                            item.value,
                          )}
                          onChange={(value: any) => {
                            subOptionHandle(value, item);
                          }}
                        >
                          <li className={`dbi-regionselecter-checkitem `}>
                            <div className="dbi-select-flex">
                              <img
                                className="dbi-select-countryicon"
                                src={getDataSourceIcon(item.icon || item.paValue)}
                              />
                              {/* <span>{item.text}</span> */}
                              <span>{formatMessage({ id: item.text })}</span>
                            </div>
                          </li>
                        </Checkbox>
                      </Bubble>
                    );
                  })}
                </Checkbox.Group>
              </div>
            </div>
          )}
        </div>
      )}
    </Dropdown>
  );
}
